export default [
  { name: 'id', label: 'ID', type: 'immutable' },
  { name: 'companyId', label: 'Company', type: 'immutable' },
  { name: 'productCode', label: 'Product', type: 'product' },
  { name: 'name', label: 'Name' },
  { name: 'startDate', label: 'Start Date', type: 'datetime' },
  { name: 'endDate', label: 'End Date', type: 'datetime' }
]



// WEBPACK FOOTER //
// ./src/fields/plans.js